/**
 * Google Maps API Configuration
 * Browser-restricted key hardcoded for autocomplete
 */

// Use the configured secret from backend
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "AIzaSyAXFlpS6YQ9C-_RGrGpsSpvhARlS6rLesw";

